import { render, staticRenderFns } from "./bulletinCommit.vue?vue&type=template&id=1d3f0c44"
import script from "./bulletinCommit.vue?vue&type=script&lang=js"
export * from "./bulletinCommit.vue?vue&type=script&lang=js"
import style0 from "./bulletinCommit.vue?vue&type=style&index=0&id=1d3f0c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports